import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9s53s0q5mf: FaireBrandEntity = {
  token: "b_9s53s0q5mf",
  type: "brand",
  name: "Circular Living",
  avatarUrl:
    "https://cdn.faire.com/fastly/06ac0c2268358c025c61ae3ae76a39f607da4ab9d56ba8b8d0986c6de46f587f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/4703f14fbf1a77bb47262e0be2b03a858b4cc59e2c019e0472538aeb48dbcd24.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/06ac0c2268358c025c61ae3ae76a39f607da4ab9d56ba8b8d0986c6de46f587f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4703f14fbf1a77bb47262e0be2b03a858b4cc59e2c019e0472538aeb48dbcd24.jpeg",
  location: "Santa Cruz, CA, USA",
  minimumOrderDollars: 120,
  rating: 5,
  reviewCount: 42,
  isTopShop: true,
  isInsider: true,
  description:
    "Handmade organic skincare honoring our bodies and the Earth. \n\nFrom renewability and purity of ingredients to plastic-free design and packaging, everything we make is intended to invite nature into your home, creating a ritual that awakens and nourishes your body and senses, leaving you feeling connected to the magic and joy of the earth. \n\nPlants are family.  ❤\n\n\n\nWe take the utmost care in sourcing our ingredients by supporting small farms and cooperatives and using vegan, non-gmo, cruelty-free, certified organic and fair trade ingredients. We scent our products with pure organic essential oils, and do not use any plant species that are vulnerable, threatened, endangered, or critically endangered like frankincense and sandalwood. \n\nOur labels are plastic-free +certified backyard compostable and we package in food safe glass. \n\nOur packing and shipping materials are all 100% plastic free. We use water activated compostable/recyclable packing tape, compostable packing peanuts that we gather from local businesses to reuse and recyclable shipping boxes. Our shipping labels are made from recycled paper and can be recycled or composted. \n\nEvery quarter we donate a minimum of 1% of our profits to  non-profit organizations or movements that are driving positive social and environmental change in the world. \n\n",
  meta: {
    source: "api",
    importedAt: "2026-05-06T18:11:36.138Z",
    importedBy: "entity-db-cli",
  },
};
